import React from 'react';
import { Box, FormControl, FormLabel, Input, Button, Typography } from '@mui/joy';
import VendorSelect from './VendorSelect';
import { today } from './MaterialForm';
import { inputSx, submitButtonSx } from './formCommon';

export const emptyInstrumentForm = () => ({
  instrument_name: '',
  purchase_date: today(),
  quantity: '',
  cost: '',
  brand: '',
  make: '',
  serial_no: '',
  vendor_id: ''
});

export const validateInstrumentForm = (form) => {
  if (!form.instrument_name?.trim() || !form.purchase_date || !form.quantity || !form.vendor_id) {
    return 'All required fields (name, date, quantity, vendor) must be filled';
  }
  if (form.vendor_id === '__add_new__') {
    return 'Please select a vendor or add one first';
  }
  if (parseInt(form.quantity, 10) <= 0) {
    return 'Quantity must be greater than 0';
  }
  return null;
};

export const instrumentFormToPayload = (form) => ({
  instrument_name: form.instrument_name.trim(),
  purchase_date: form.purchase_date,
  quantity: parseInt(form.quantity, 10),
  cost: form.cost !== '' ? form.cost : null,
  vendor_id: form.vendor_id ? parseInt(form.vendor_id, 10) : null,
  brand: form.brand || null,
  make: form.make || null,
  serial_no: form.serial_no || null
});

const InstrumentForm = ({
  form,
  onChange,
  onSubmit,
  loading = false,
  vendors = [],
  vendorsLoading = false,
  onAddVendor,
  submitLabel = 'Add Instrument',
  fullWidthSubmit = true
}) => (
  <form onSubmit={onSubmit}>
    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Instrument Name</FormLabel>
      <Input
        name="instrument_name"
        value={form.instrument_name}
        onChange={onChange}
        required
        placeholder="Enter instrument name"
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Purchase Date</FormLabel>
      <Input type="date" name="purchase_date" value={form.purchase_date} onChange={onChange} required sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Quantity</FormLabel>
      <Input type="number" name="quantity" value={form.quantity} onChange={onChange} required min="1" sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Cost (per unit)</FormLabel>
      <Input
        type="number"
        name="cost"
        value={form.cost}
        onChange={onChange}
        min="0"
        step="0.01"
        startDecorator={<Typography sx={{ color: 'text.tertiary', fontWeight: 500 }}>₹</Typography>}
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Brand</FormLabel>
      <Input name="brand" value={form.brand} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Make</FormLabel>
      <Input name="make" value={form.make} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Serial No (optional)</FormLabel>
      <Input name="serial_no" value={form.serial_no} onChange={onChange} sx={inputSx} />
    </FormControl>

    <VendorSelect
      vendors={vendors}
      value={form.vendor_id || ''}
      onChange={(vendorId) => onChange({ target: { name: 'vendor_id', value: vendorId } })}
      onAddNew={onAddVendor}
      loading={vendorsLoading}
      required
    />

    <Box sx={{ display: 'flex', justifyContent: fullWidthSubmit ? 'stretch' : 'flex-end', mt: 1 }}>
      <Button type="submit" loading={loading} fullWidth={fullWidthSubmit} sx={submitButtonSx}>
        {submitLabel}
      </Button>
    </Box>
  </form>
);

export default InstrumentForm;
